import React, {useEffect} from "react";
import {Helmet} from "react-helmet";
import $ from 'jquery';
import jQuery from 'jquery';
import './Components/jquery-imports-setup';
import {BasicImportCss} from "./Components/BasicImportCss";
import {NavBar} from "./Components/NavBar";
import {Footer} from "./Components/Footer";


export const CartLager = (effect, deps) => {

    return (
        <React.Fragment>

            <BasicImportCss/>

            <div className="wrapper" style={{display: "none"}}>

                <NavBar/>

                <section className="main-header" style={{backgroundImage: 'url(assets/images/gallery-2.jpg)'}}>
                    <header>
                        <div className="container text-center">
                            <h2 className="h2 title">Checkout</h2>
                            <ol className="breadcrumb breadcrumb-inverted">
                                <li><a href="index.html"><span className="icon icon-home"></span></a></li>
                                <li><a className="active" href="checkout-1.html">Cart items</a></li>
                                <li><a href="checkout-2.html">Delivery</a></li>
                                <li><a href="checkout-3.html">Payment</a></li>
                                <li><a href="checkout-4.html">Receipt</a></li>
                            </ol>
                        </div>
                    </header>
                </section>


                <div className="step-wrapper">
                    <div className="container">

                        <div className="stepper">
                            <ul className="row">
                                <li className="col-md-3 active">
                                    <span data-text="Cart items"></span>
                                </li>
                                <li className="col-md-3">
                                    <span data-text="Delivery"></span>
                                </li>
                                <li className="col-md-3">
                                    <span data-text="Payment"></span>
                                </li>
                                <li className="col-md-3">
                                    <span data-text="Receipt"></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <section className="checkout">

                    <div className="container">

                        <header className="hidden">
                            <h3 className="h3 title">Checkout - Step 1</h3>
                        </header>


                        <div className="cart-wrapper">


                            <div className="cart-block cart-block-header clearfix">
                                <div>
                                    <span>Product</span>
                                </div>
                                <div>
                                    <span>&nbsp;</span>
                                </div>
                                <div>
                                    <span>Quantity</span>
                                </div>
                                <div className="text-right">
                                    <span>Price</span>
                                </div>
                            </div>


                            <div className="clearfix">
                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img src="assets/images/product-7.png" alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div className="h4"><a href="product.html">Coffee machine</a></div>
                                        <div>Electronics</div>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final h3">$ 150,00</span>
                                        <span className="discount">$ 190,00</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>

                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img src="assets/images/product-8.png" alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div className="h4"><a href="product.html">Iron set</a></div>
                                        <div>Home accessories</div>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final h3">$ 390,00</span>
                                        <span className="discount">$ 490,00</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>

                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img src="assets/images/product-10.png" alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div className="h4"><a href="product.html">Wireless Headphones</a></div>
                                        <div>Green corner</div>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final h3">$ 180,00</span>
                                        <span className="discount">$ 200,00</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>

                                <div className="cart-block cart-block-item clearfix">
                                    <div className="image">
                                        <a href="product.html"><img src="assets/images/product-12.png" alt=""/></a>
                                    </div>
                                    <div className="title">
                                        <div className="h4"><a href="product.html">E-shaver 500</a></div>
                                        <div>Electronics</div>
                                    </div>
                                    <div className="quantity">
                                        <input type="number" value="2" className="form-control form-quantity"/>
                                    </div>
                                    <div className="price">
                                        <span className="final h3">$ 199,00</span>
                                        <span className="discount">$ 149,00</span>
                                    </div>

                                    <span className="icon icon-cross icon-delete"></span>
                                </div>
                            </div>


                            <div className="clearfix">
                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>Discount 15%</strong>
                                    </div>
                                    <div>
                                        <span>$ 159,00</span>
                                    </div>
                                </div>

                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>Shipping</strong>
                                    </div>
                                    <div>
                                        <span>$ 30,00</span>
                                    </div>
                                </div>

                                <div className="cart-block cart-block-footer clearfix">
                                    <div>
                                        <strong>VAT</strong>
                                    </div>
                                    <div>
                                        <span>$ 59,00</span>
                                    </div>
                                </div>
                            </div>


                            <div className="clearfix">
                                <div className="cart-block cart-block-footer cart-block-footer-price clearfix">
                                    <div>
                                <span className="checkbox">
                                    <input type="checkbox" id="couponCodeID" />
                                    <label htmlFor="couponCodeID">Promo code</label>
                                    <input type="text" className="form-control form-coupon" value=""
                                           placeholder="Enter your coupon code" />
                                </span>
                                    </div>
                                    <div>
                                        <div className="h2 title">$ 1259,00</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="clearfix">
                            <div className="row">
                                <div className="col-xs-6">
                                    <a href="#" className="btn btn-clean-dark"><span
                                        className="icon icon-chevron-left"></span> Shop more</a>
                                </div>
                                <div className="col-xs-6 text-right">
                                    <a href="checkout-2.html" className="btn btn-main"><span
                                        className="icon icon-cart"></span> Proceed to delivery</a>
                                </div>
                            </div>
                        </div>

                    </div>


                </section>

                <Footer/>

            </div>

        </React.Fragment>
);
}